<template>
  <div>
    <headBox title="产品访客事件"></headBox>
    <div class="tbd-content">
      <!-- 搜索部分 -->
      <topSearchForm @search="searchAjax" @export="exportToExcel">
        <el-form :inline="true" class="rform" :model="searchParams" ref="loginform" label-width="80px">
          <el-form-item label="日期">
            <a-range-picker v-model="searchParams.dateTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>

          <el-form-item label="产品名称">
            <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item label="产品编号">
            <el-input v-model="searchParams.productNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <el-table
        border
        :data="tableData"
        class="list-table"
        tooltip-effect="dark"
        v-loading="listLoading"
        @sort-change="sortChange"
        :default-sort="{ prop: 'policyNum', order: 'descending' }"
      >
        <el-table-column label="序号" width="50px;" type="index"></el-table-column>
        <el-table-column label="产品名称" property="productName" min-width="150px;" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="保险公司" min-width="100px;" property="companyName"></el-table-column>
        <el-table-column label="产品编号" property="productNo"></el-table-column>
        <el-table-column label="产品UV" property="productUv" sortable="custom">
          <template slot-scope="scope">
            <div>{{ scope.row.productUv }}人</div>
          </template>
        </el-table-column>
        <el-table-column label="产品PV" property="productPv" sortable="custom">
          <template slot-scope="scope">
            <div>{{ scope.row.productPv }}次</div>
          </template>
        </el-table-column>
        <el-table-column property="startTime" min-width="120px;" label="开始时间">
          <template slot-scope="scope">
            {{ scope.row.startTime }}
          </template>
        </el-table-column>
        <el-table-column label="停留时长" property="totalDuration" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.totalDuration == '00:00:00' ? '-' : scope.row.totalDuration }}
          </template>
        </el-table-column>
        <el-table-column label="成交量" property="policyNum" sortable="custom"></el-table-column>
        <el-table-column label="月成交转化率" min-width="100px;" property="volRate2" sortable="custom"></el-table-column>
        <el-table-column label="周成交转化率" min-width="100px;" property="volRate3" sortable="custom"></el-table-column>
        <el-table-column label="日成交转化率" min-width="100px;" property="volRate4" sortable="custom"></el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :layout="$tools.pageLayout"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//当前实例组件
import topSearchForm from '@/components/topSearchForm.vue';
import headBox from '@/components/head.vue';
import { common, pageTool } from '@/api/mixins';
import dayjs from 'dayjs';

export default {
  components: {
    headBox,
    topSearchForm
  },
  mixins: [common, pageTool],
  data: () => ({
    sortParams: {
      asc: false,
      orderBy: 'policyNum'
    }
  }),

  created() {
    this.initListAjax('/master/productVisitor/queryProductStatistics');
  },

  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    setListParams(params) {
      if (params.dateTime && params.dateTime[0]) {
        params.startTimeStart = dayjs(params.dateTime[0]).format('YYYY-MM-DD');
        params.startTimeEnd = dayjs(params.dateTime[1]).format('YYYY-MM-DD');
      }
      if (this.sortParams.asc !== null) {
        params.asc = this.sortParams.asc;
        params.orderBy = this.sortParams.orderBy;
      } else {
        delete params.asc;
        delete params.orderBy;
      }
      delete params.dateTime;
    },
    sortChange({ prop, order }) {
      if (order) {
        this.sortParams.asc = order == 'ascending' ? true : false;
      } else {
        this.sortParams.asc = null;
      }
      this.sortParams.orderBy = prop;
      this.getList();
    },

    // 导出
    exportToExcel() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$tools.daochu('/master/productVisitor/exportProductStatistics', params, 'PUT');
    }
  }
};
</script>

<style lang="scss" scoped>
.tbd-content {
  background: #ffffff;
  padding: 20px 30px 30px 30px;
}

// .el-pagination {
//   margin-top: 50px;
// }

.list-table {
  margin-top: 20px;
  .cell {
    text-align: center;
  }
  .is-left {
    .cell {
      text-align: left;
    }
  }
}
</style>